export default function SubmitButton({ text }) {
  return (
    <button
      type="submit"
      className="bg-[#1E3A5F] text-[#FFC107] hover:bg-[#2B5388] hover:text-[#D19D00] font-medium py-2.5 px-4 rounded-md w-full mt-2 transition duration-200"
    >
      {text}
    </button>
  );
}

